<style>
  a {
    color: inherit;
  }
</style>
<p>
  &copy; {{ year }} -
  <a href="http://www.neatlines.uk/" target="_blank" tabindex="-1"
    >N&Xi;ATLIN&Xi;S</a
  >
</p>
